import { Service, ContactInfo, SocialLink, Feature, PetSize, GoogleTag, Comment, ReviewLinks } from '../types';

export const services: Service[] = [
  {
    id: '5-star-bath',
    name: '5-Star Bath',
    description: 'Give your pet the spa day they deserve! This all-inclusive experience uses only premium products leaving your pet clean, soft, and beautifully refreshed.',
    icon: 'bath',
    features: [
      'A luxurious bath with high-quality shampoo & conditioner tailored to coat needs',
      'Gentle ear cleaning & care to promote healthy ears',
      'A cozy towel wrap followed by hand blow-dry/fluff-dry & 5-minute massage for total relaxation',
      'Full body brushing for a healthy, shiny coat',
      'A light mist of premium cologne for lasting freshness',
      'A stylish bandana, bow or accessory for the perfect finishing touch'
    ],
    price: {
      small: 60,
      medium: 70,
      large: 80,
      xlarge: 110
    }
  },
  {
    id: 'premium-touch-up',
    name: 'Mini-Groom',
    description: 'Perfect for pets who need more than a bath but not a full haircut. Includes the 5-Star Bath plus a mini groom with sanitary trim, paw pad shave, and light scissor work to keep your pet comfortable, neat, and stylish.',
    icon: 'premium',
    features: [
      'A luxurious bath with high-quality shampoo & conditioner tailored to coat needs',
      'Gentle ear cleaning & care to promote healthy ears',
      'A cozy towel wrap followed by hand blow-dry/fluff-dry & 5-minute massage for total relaxation',
      'Full body brushing for a healthy, shiny coat',
      'Nail clipping & filing for comfort and mobility',
      'Refreshing oral care with toothbrush and fresh-breath spray',
      'Paw pad cleaning & shave for comfort and cleanliness',
      'Small shear trim for a polished, photo-ready look (2 areas of choice including tail, ears, eyes, etc)',
      'A light mist of premium cologne for lasting freshness',
      'A stylish bandana, bow or accessory for the perfect finishing touch'
    ],
    price: {
      small: 80,
      medium: 95,
      large: 110,
      xlarge: 150
    }
  },
  {
    id: 'royal-treatment',
    name: 'Full Groom',
    description: 'The ultimate pampering experience. Includes everything from the Mini-Groom plus a full haircut with delicate finishing touches. Your pet will leave looking absolutely stunning from nose to tail.',
    icon: 'royal',
    features: [
      'A luxurious bath with high-quality shampoo & conditioner tailored to coat needs',
      'Gentle ear cleaning & care to promote healthy ears',
      'A cozy towel wrap followed by hand blow-dry/fluff-dry & 5-minute massage for total relaxation',
      'Full body brushing for a healthy, shiny coat',
      'Nail clipping & filing for comfort and mobility',
      'Refreshing oral care with toothbrush and fresh-breath spray',
      'Paw pad cleaning & shave for comfort and cleanliness',
      'Small shear trim for a polished, photo-ready look (2 areas of choice including tail, ears, eyes, etc)',
      'A full-body trim or shave to your preferred style',
      'Custom haircut & scissor finishing for an elegant result',
      'A light mist of premium cologne for lasting freshness',
      'A stylish bandana, bow or accessory for the perfect finishing touch'
    ],
    price: {
      small: 90,
      medium: 110,
      large: 135,
      xlarge: 190
    }
  }
];

export const features: Feature[] = [
  {
    id: 'mobile',
    title: 'Mobile',
    description: 'Luxury Mercedes 3500 grooming salon brought to your doorstep',
    icon: 'van'
  },
  {
    id: 'premium-products',
    title: 'Premium Products',
    description: 'High-quality grooming products for a healthier, happier pet',
    icon: 'star'
  },
  {
    id: 'caring',
    title: 'Caring',
    description: 'Passionate care, treating your pet like our own',
    icon: 'heart'
  },
  {
    id: 'custom',
    title: 'Custom',
    description: 'Every groom tailored to your pet\'s needs and style',
    icon: 'lightning'
  },
  {
    id: 'cage-free',
    title: 'Cage-free',
    description: 'One-on-one attention in a comfortable stress-free environment',
    icon: 'house'
  },
  {
    id: 'family-owned',
    title: 'Family-owned',
    description: 'Pet grooming with love, from our family to yours',
    icon: 'paw'
  }
];

export const petSizes: PetSize[] = [
  {
    id: 'small',
    name: 'SMALL',
    weight: 'up to 15 lbs',
    color: 'green',
    icon: 'S'
  },
  {
    id: 'medium',
    name: 'MEDIUM',
    weight: '16-40 lbs',
    color: 'blue',
    icon: 'M'
  },
  {
    id: 'large',
    name: 'LARGE',
    weight: '41-70 lbs',
    color: 'purple',
    icon: 'L'
  },
  {
    id: 'xlarge',
    name: 'XL',
    weight: '71+ lbs',
    color: 'orange',
    icon: 'XL'
  }
];

// Dados específicos para a seção Simple Pricing
export const pricingServices = [
  {
    id: '5-star-bath-short',
    name: '5-Star Bath Short Hair',
    prices: { small: 60, medium: 70, large: 80, xlarge: 110 }
  },
  {
    id: '5-star-bath-long',
    name: '5-Star Bath Long Hair',
    prices: { small: 70, medium: 85, large: 95, xlarge: 130 }
  },
  {
    id: 'mini-groom',
    name: 'Mini-Groom',
    prices: { small: 80, medium: 95, large: 110, xlarge: 150 }
  },
  {
    id: 'full-groom',
    name: 'Full Groom',
    prices: { small: 90, medium: 110, large: 135, xlarge: 190 }
  }
];

export const contactInfo: ContactInfo = {
  phone: '(321) 662-6756',
  email: 'contact@mypremiumpets.com',
  address: '123 Pet Street, City, State 12345',
  hours: 'Mon-Fri: 8:30AM-7PM',
  hoursWeekend: 'Sat: 08:30AM-2PM',
  serviceArea: 'Greater The Villages Area'
};

export const socialLinks: SocialLink[] = [
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/premiumpetsgrooming?igsh=eXVnbGx3YnV0c25q',
    icon: 'instagram'
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/share/1Ba3nZozav/?mibextid=wwXIfr',
    icon: 'facebook'
  }
];

export const googleTag: GoogleTag = {
  scriptSrc: 'https://www.googletagmanager.com/gtag/js?id=AW-17701027103',
  inlineScript: `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-17701027103');
`
};

export const comments: Comment[] = [
  {
    id: '1',
    name: 'Brianna Engdahl',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjWyDFjnxJrEYgSinsLDtn1YS4jk5VSRh-aJN22FLEcXLcB37LeG=w72-h72-p-rp-mo-br100',
    text: 'So beyond happy with our experience. They took a chance on our cane corso Juno after she was turned down by another groomer. She looks and smells amazing!',
    rating: 5,
    date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    platform: 'google'
  },
  {
    id: '2',
    name: 'Shirley Cianciolo',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjUEkqAQqjRLFaOOMgFPFGrYgkqUnisAcN-gYkgBgoV1s4SMdM8c=w72-h72-p-rp-mo-br100',
    text: 'Premium pets did so great with our 3 dogs,l! Were super caring towards them and their cuts looked amazing! They will definitely be our new groomers!',
    rating: 5,
    date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    platform: 'google',
    commentPhotos: [
      'https://lh3.googleusercontent.com/geougc-cs/AMBA38sYyvxQ8In7gNwcK-viAvd33MCqRC-m1qTgQedyU4gojARTJ1BzITPwhmHzcPOvYDa2PtXPRhDNkpwKIacCucsbw98ID5s8gbC4qMm8IB8o4OKtBFObsz1uZpbCaSEqOf163-Z-ykpjZcZt=s3442-w3442-h2458',
    ]
  },
  {
    id: '3',
    name: 'Hayley Hetherley',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjUjiMe_HwWxhDurHHUjJTG-Hzvi076Ll38dZSc8XrMJalrspYbDTw=w72-h72-p-rp-mo-br100',
    text: 'I had all three of my dogs groomed by Premium Pets Mobile Grooming, and I couldn\'t be happier with the experience! They arrived right on time, were incredibly compassionate, and treated each of my pups with so much sweetness and care. The grooming van was spotless, and you can tell they truly prioritize cleanliness and comfort.\n\nMy senior dog gets very stressed when leaving the house, so having them come right to us made such a huge difference. He was calm, safe, and so much more at ease than with traditional grooming. They even groom cats, which is such a bonus!\n\nPremium Pets has definitely earned a loyal customer — I\'ll be using them from now on. Highly recommend!',
    rating: 5,
    date: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    platform: 'google'
  },
  {
    id: '4',
    name: 'Ava Polan',
    photoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocKh6kNqP-dsKJKC15fYrCNnCwQi7Fuz2x_GdZJsgZl82pYQJA=w72-h72-p-rp-mo-br100',
    text: 'Fantastic service! Cyrus looks great and is a happy pupper. Lou and Sonny were gentle with him and I cannot recommend them highly enough. Their beautiful grooming van comes right to your house...what a tremendous convenience! Here\'s Cyrus post-spa luxuriating with his emotional support chicken.',
    rating: 5,
    date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    platform: 'google',
    commentPhotos: [
      'https://lh3.googleusercontent.com/geougc-cs/AMBA38vaEuRArzjNRDsAwCmbs5iJCEeX-YIBtWUiHXU9QMB10itXvrsMG7rUrjtmBvI_pdeoarXgWOF6W9JUx5X805HJAjZSZRrznBivD6AGrZHYLGCTwk2Lv6t343qV8cdfdPHtDVQFuQ3GQ88=w600-h450-p'
    ]
  },
  {
    id: '5',
    name: 'Donna Moon',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjVZcP8oY3GaUEXrhJgPbNjJJxk2nIYbKUkhQTRr-B6HW_wsHjTh=w72-h72-p-rp-mo-br100',
    text: 'This was Molly’s first time with Lou at Premium Pet’s. But she came out of the van a very happy girl with her tail wagging. Lou said she did very well. She was so cute. She was so smooth and silky and she smelled so good. We will be booking again for sure.',
    rating: 5,
    date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    platform: 'google',
    commentPhotos: [
      'https://lh3.googleusercontent.com/geougc-cs/AMBA38u_WC9oSjTyeXRCgJucHqXLfRFX0znBEniFCE5A_c5SOdy9vGPMC-1MYnQSa-caRkcOJ5VnfdATcGU3NEAOouADp3vgDfEMfql_mHWxOyWIstnSYSXj2G76X7mwdyXcv1-zAxa0Hood3Vsd=s3442-w3442-h2458'
    ]
  },
  {
    id: '6',
    name: 'Tiffany Vazquez',
    photoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocJPhgC8JezDg4WQIjnvuBvE0uc05dkvQQJNMMR05F4bDrZybg=w72-h72-p-rp-mo-br100',
    text: 'Lou and family were so patient and loving with my babies! They did an awesome job with both of them.',
    rating: 5,
    date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    platform: 'google',
    commentPhotos: [
      'https://lh3.googleusercontent.com/geougc-cs/AMBA38tehIKyg1HkJCO4BK8ycNcQPFrzmu-jIbsla7bVMCPH_GBRu3oJB0IcT5EPvtF2tgtPxdC0Npau6JjI6jtNBeN7ac_6jwOIiRZJjvrOK0xafzkbu6mjFDgA0vHczYxWgPoyWZTAM_O7STQt=s3442-w3442-h2458',
      'https://lh3.googleusercontent.com/geougc-cs/AMBA38sLrMEkdUs088puYN2IMEu7Vs1xSi_-78TLN5NoDLKDB9cq2spXUA-69hnsd70bbS8VNt-6MuRdyJt1qIaI6Kt5IYERp5ynwHi7w6SR3KmkIzHT7eZZ9oc6utvgAk629xffq1drZlsG37YY=s3442-w3442-h2458',
    ]
  }
];

export const reviewLinks: ReviewLinks = {
  googleUrl: 'https://share.google/anqgzHPxThRK0XoYT',
  nextdoorUrl: 'https://nextdoor.com/pages/premium-pets-wildwood-fl/'
};


